import { useEffect, useState } from "react";

/**
 * Reactive `navigator.onLine`. Components that need to disable destructive
 * actions when the device is offline (Modify/Cancel/Delete in
 * FlightDetailModal, the chat send button, etc.) read this to flip their
 * `disabled` prop on the fly without needing a poll loop.
 *
 * SSR-safe: returns `true` if `navigator` is not defined (server render).
 */
export default function useOnline(): boolean {
  const [online, setOnline] = useState<boolean>(
    typeof navigator === "undefined" ? true : navigator.onLine
  );

  useEffect(() => {
    const onOnline = (): void => setOnline(true);
    const onOffline = (): void => setOnline(false);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  return online;
}
